import React from "react";
import { Button } from "@mui/material";

import OTPInput from "../../components/OtpInput";
import IWA from "../../assets/images/input-whatsapp.svg";

export default function OTPForm({
  data = {},
  setData = () => {},
  resendOtpHandler = () => {},
  otpSubmitHandler = () => {},
  verifying = false,
}) {
  const [resendPressed, setResendPressed] = React.useState(false);
  return (
    <>
      <div
        style={{ textAlign: "center", paddingTop: "2rem", color: "#FFFFFF" }}
      >
        <span style={{ fontSize: "1.2em" }}>OTP verification</span>
        <p
          style={{ color: "#6F7379", fontSize: "0.8em", marginBottom: "2rem" }}
        >
          Please enter OTP sent on your WhatsApp No. <br />
          <img
            loading="lazy"
            src={IWA}
            alt=""
            style={{
              objectFit: "contain",
              height: "14px",
              width: "14px",
              marginRight: "4px",
              marginBottom: "-3px",
            }}
          />
          <b>+91 {data.phone || "9876543210"}</b>
        </p>
        <OTPInput onChangeOTP={(v) => setData({ ...data, otp: v })} />
        <Button
          onClick={() => {
            setResendPressed(true);
            resendOtpHandler(false);
          }}
          style={{
            margin: "1rem 0",

            fontWeight: "500",
            fontSize: "16px",
          }}
          // size="small"
        >
          {resendPressed && verifying ? "Resending..." : "Resend OTP"}
        </Button>
      </div>
      <div className="request-footer-btn">
        <Button
          id="step-3-onboarding"
          disabled={verifying || !data.otp || data.otp?.length !== 6}
          onClick={() => {
            setResendPressed(false);
            otpSubmitHandler();
          }}
          style={{
            padding: "16px 0",
            fontSize: "1em",

            background:
              verifying || !data.otp || data.otp?.length !== 6
                ? "#383838"
                : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color:
              verifying || !data.otp || data.otp?.length !== 6
                ? "#232323"
                : "#FF4A01",
          }}
          fullWidth
          variant="contained"
          size="large"
        >
          {!resendPressed && verifying ? "Verifying..." : "Continue"}
        </Button>
      </div>
    </>
  );
}
